import { FC, ReactElement } from 'react'
import styled from 'styled-components'
import ListItem from 'components/ListItem'
import { device } from '../breakpoints'

interface ListProps {
  data: any
}

const List: FC<ListProps> = ({ data }): ReactElement => {
  return (
    <Container>
      {data.length > 0 && (
        <ItemsContainer>
          {data.map((item: any, index: number) => (
            <ListItem
              id={item.id}
              name={item['name']}
              lastName={item['lastName']}
              imageElvisId={item['imageElvisId']}
              gender={item['genre'] === 'Femme' ? 'f' : 'm'}
              age={item['age']}
              location={item['location']}
              businessName={item['businessName']}
              imageFocusPointX={
                item['imageFocusPointX'] ? item['imageFocusPointX'] : '0.5'
              }
              imageFocusPointY={
                item['imageFocusPointY'] ? item['imageFocusPointY'] : '0.5'
              }
              imageCropOffsetX={
                item['imageCropOffsetX'] ? item['imageCropOffsetX'] : '0'
              }
              imageCropOffsetY={
                item['imageCropOffsetY'] ? item['imageCropOffsetY'] : '0'
              }
              imageCropWidth={
                item['imageCropWidth'] ? item['imageCropWidth'] : '1'
              }
              imageCropHeight={
                item['imageCropHeight'] ? item['imageCropHeight'] : '1'
              }
              key={`item-${item.id}`}
              text={item.text}
              mainSector={item.mainSector}
              links={item.providerLinks}
            />
          ))}
        </ItemsContainer>
      )}
    </Container>
  )
}

const Container = styled.div`
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
`

const ItemsContainer = styled.div`
  display: grid;
  min-width: 0;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    grid-template-columns: repeat(1, 1fr);
  }

  @media ${device.tablet}, @media ${device.laptop} {
    grid-template-columns: repeat(2, 1fr);
  }

  @media ${device.laptopL} {
    grid-template-columns: repeat(3, 1fr);
  }
`

export default List
